<template>
    <div class="level-item">
        <spinner v-if="loading" :size="24" />

        <span v-else-if="others.length > 1">
            You, {{ onlineStatus ? 'online' : 'offline' }}{{ others[0].name }} & others
        </span>

        <span v-else-if="others[0] && others[0].name" class="is-align-center">
            <user-status :status="onlineStatus" current />

            {{ others[0].name }}
        </span>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import Spinner from './Spinner.vue';
import UserStatus from './UserStatus.vue';

const { mapState } = createNamespacedHelpers('Chat');

export default {
    name: 'HeaderTitle',

    components: { Spinner, UserStatus },

    props: {
        participants: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        online: {
            type: Object,
            default: () => {},
        },
    },

    computed: {
        ...mapState(['authUser']),

        others() {
            return this.participants.filter(participant => participant.id !== this.authUser.id);
        },

        onlineStatus() {
            return !!this.online[this.others[0].id];
        },
    },
};
</script>
